<template>
  <button
    :class="['mbtn', { disabled, loading }]"
    :style="style"
    v-bind="$attrs"
    :disabled="disabled"
    v-on="$listeners"
  >
    <slot v-if="loading" name="loading">
      <MLoadingIcon width="1em" height="1em" />
    </slot>
    <slot name="icon" />
    <span class="mbtn-core">
      <slot>
        {{ text }}
      </slot>
    </span>
  </button>
</template>

<script>
import MLoadingIcon from '../MLoadingIcon/index.vue';

export default {
  components: { MLoadingIcon },
  props: {
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    text: { type: String, default: '' },
  },
  computed: {
    style() {
      const { bg, color, round } = this.$attrs;
      const s = {};
      color ? (s['background-color'] = color) : '';
      bg ? (s['background-bg'] = color) : '';
      return s;
    },
  },
};
</script>

<style scoped lang="scss">
.mbtn {
  border: 1px solid #d1d5db;
  background: #fff;
  border-radius: 8px;
  height: 40px;
  line-height: 40px;
  min-width: 156px;
  display: flex;
  align-items: center;
  justify-content: center;
  &[primary] {
    background: $primary;
    color: #fff;
    border: none;
  }
  &[disabled] {
    background: $disabledBg;
    color: $disabledFont;
  }
  &.disabled {
    background: $disabledBg;
    color: $disabledFont;
  }
  &.loading {
    pointer-events: none;
  }
}
</style>
